import React, { useState } from 'react';
import { ESSButton } from '../Atoms/ESSButton';
import { ESSMenu, MenuItem } from '../Molecules/Menu';

/**
 * MenuExample - Functional example of Menu component
 * Shows dropdown menus with different variants
 */
const MenuExample = () => {
  const [openMenu, setOpenMenu] = useState(null);

  const handleMenuItemClick = (action) => {
    alert(`You clicked: ${action}`);
    setOpenMenu(null);
  };

  const menus = [
    {
      id: 'default',
      variant: 'default',
      label: 'Default Menu',
      items: ['Edit', 'Duplicate', 'Archive', 'Delete'],
    },
    {
      id: 'compact',
      variant: 'compact',
      label: 'Compact Menu',
      items: ['Copy', 'Cut', 'Paste', 'Select All'],
    },
  ];

  return (
    <div className="menu-example">
      <div className="menu-example__grid">
        {menus.map((menu) => (
          <div key={menu.id} className="menu-example__item">
            <div className="menu-example__trigger">
              <ESSButton
                size="sm"
                onClick={() =>
                  setOpenMenu(openMenu === menu.id ? null : menu.id)
                }
              >
                {menu.label} ▼
              </ESSButton>
              {openMenu === menu.id && (
                <div className="menu-example__dropdown">
                  <ESSMenu variant={menu.variant}>
                    {menu.items.map((item, index) => (
                      <MenuItem
                        key={index}
                        onClick={() => handleMenuItemClick(item)}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </ESSMenu>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Click outside to close */}
      {openMenu && (
        <div
          className="menu-example__overlay"
          onClick={() => setOpenMenu(null)}
        />
      )}

      <style jsx>{`
        .menu-example__grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 2rem;
          padding: 2rem;
        }

        .menu-example__item {
          display: flex;
          justify-content: center;
        }

        .menu-example__trigger {
          position: relative;
          display: inline-block;
        }

        .menu-example__dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          margin-top: 0.5rem;
          z-index: 1001;
          animation: slideDown 0.2s ease-out;
        }

        .menu-example__overlay {
          position: fixed;
          inset: 0;
          z-index: 1000;
          background: transparent;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default MenuExample;
